import { Route } from '@angular/router';
import { CsiComponent } from './csi.component';

export const CSIRoutes: Route = {
  path: '',
  component: CsiComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'contracts',
    },
    {
      path: 'contracts',
      loadComponent: () => import('./csi-contracts/csi-contracts.component').then((m) => m.CsiContractsComponent),
    },
    {
      path: 'contracts/:id',
      loadComponent: () =>
        import('./csi-contracts/csi-contract-summary/csi-contract-summary.component').then(
          (m) => m.CsiContractSummaryComponent
        ),
    },
    {
      path: 'contracts/:parentId/land/:landId',
      loadComponent: () => import('./shared/csi-land/csi-land.component').then((m) => m.CsiLandComponent),
    },
    {
      path: 'contracts/:parentId/plantation/:plantationId',
      loadComponent: () => import('./shared/csi-plantation/csi-plantation.component').then((m) => m.CsiPlantationComponent),
    },
    {
      path: 'sub-contracts',
      loadComponent: () =>
        import('./csi-subcontracts/csi-subcontracts.component').then((m) => m.CsiSubcontractsComponent),
    },
    {
      path: 'sub-contracts/:id',
      loadComponent: () =>
        import('./csi-subcontracts/csi-subcontract-summary/csi-subcontract-summary.component').then(
          (m) => m.CsiSubcontractSummaryComponent
        ),
    },
    
    {
      path: 'milestones',
      loadComponent: () => import('./csi-milestones/csi-milestones.component').then((m) => m.CsiMilestonesComponent),
    },
    {
      path: 'progressReport',
      loadComponent: () => import('./csi-progress-report/csi-progress-report.component').then(
        (m) => m.CsiProgressReportComponent
      ),
    },
  ],
};
